// DealerOnboard URLs
export const DEALER_ONBOARD_FORM_URL = 'https://info.acvmax.com/l/921243/2025-11-03/dss8ts';
export const DEALER_ONBOARD_IMAGES = {
  portalHeaderBg: '/static/images/portal-header-bg.png',
  clearcarLogo: '/static/images/clearcar_logo.png',
  shapeBehindForm: '/static/images/shape-behind-form.png',
  linkedin: '/static/images/icon-linkedin.svg',
  instagram: '/static/images/icon-instagram.svg',
  facebook: '/static/images/icon-facebook.svg',
  twitter: '/static/images/icon-twitter.svg',
  apple: '/static/images/apple.svg',
  google: '/static/images/google.svg',
};
export const DEALER_ONBOARD_SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/company/acv-auctions/',
  instagram: 'http://instagram.com/acvauctions/',
  facebook: 'https://www.facebook.com/acvauctions/',
  twitter: 'https://x.com/ACVAuctions',
};
export const DEALER_ONBOARD_APP_LINKS = {
  appStore: 'https://apps.apple.com/us/app/acv-auctions/id969808943',
  playStore: 'https://play.google.com/store/apps/details?id=com.acvauctions.acvauctions&pli=1',
};
export const RedirectPathKey = 'path';

export const Severity = {
  Low: 'low',
  Medium: 'medium',
  High: 'high',
};

export const SeverityLabel = {
  Low: 'Minor',
  Medium: 'Moderate',
  High: 'Major',
};

export const pageTypes = {
  Leads: 'leads',
  Appointment: 'appointment',
  Appraisals: 'appraisals',
};

export const appraisalSeverityTypes = {
  Info: 'info',
  Warning: 'warning',
  Success: 'success',
};

export const disclosureAnswerTypes = {
  Severity: 'severity',
  Types: 'types',
  Choice: 'choice',
  Default: 'default',
};

// Colors from component-lib
export const VehicleDamageDefaultSeverityColor = {
  [Severity.Low]: '#FFEFBF',
  [Severity.Medium]: '#FEF2EC',
  [Severity.High]: '#FFDAD6',
};

export const disclosureAnswerKeys = {
  rust_damage: { key: 'rust_damage', type: disclosureAnswerTypes.Severity },
  option_equipment: {
    key: 'option_equipment',
    issue: null,
    alert: false,
  },
  body_damage: {
    key: 'body_damage',
    type: disclosureAnswerTypes.Severity,
    alert: false,
  },
  engine_issues: {
    key: 'engine_issues',
    type: disclosureAnswerTypes.Types,
    alert: false,
  },
  interior_issues: {
    key: 'interior_issue',
    type: disclosureAnswerTypes.Types,
    alert: false,
  },
  mechanical_issues: {
    key: 'mechanical_issue',
    type: disclosureAnswerTypes.Types,
    alert: false,
  },
  warning_lights: {
    key: 'warning_lights',
    type: disclosureAnswerTypes.Types,
    alert: false,
  },
  modifications: {
    key: 'modifications',
    type: disclosureAnswerTypes.Types,
    alert: false,
  },
  tire_issues: {
    key: 'tire_issues',
    type: disclosureAnswerTypes.Types,
    alert: false,
  },
  tire_tread: {
    key: 'tire_tread',
    type: disclosureAnswerTypes.Choice,
    issue: 'poor',
    alert: false,
  },
  glass_damage: {
    key: 'glass_damage',
    type: disclosureAnswerTypes.Default,
    alert: false,
  },
};

export const bodyDamageValues = ['Minor', 'Moderate', 'Major'];

export const appraisalType = {
  advocateAppraisal: {
    title: 'Customer Advocate Appraisal',
    severity: appraisalSeverityTypes.Info,
  },
  dealerAppraisal: {
    title: 'Dealer Appraisal',
    severity: appraisalSeverityTypes.Warning,
  },
  customerAppraisal: {
    title: 'Consumer Appraisal',
    severity: appraisalSeverityTypes.Success,
  },
};

export const AppraisalSourceBy = {
  Appraisal: {
    key: 'appraisal_offer',
    status: 'appraisal',
  },
  Advocate: {
    key: 'reviewed_offer',
    status: 'appointment',
  },
  Consumer: {
    key: 'online_offer',
    status: 'lead',
  },
};

export const Locales = {
  us: 'en-US',
};

export const DateFormating = {
  appointment: 'YYYY-MM-DD | hh:mm A',
};

export const DateFormats = {
  mm_dd_yy: 'MM/DD/YY',
  mmmm_d_yyyy: 'MMMM D, YYYY',
  ddd_mmmm_d_yyyy: 'dddd, MMMM D, YYYY',
  h_mm_A: 'h:mm A',
  yyyy_mm_dd: 'YYYY/MM/DD',
  MDYY_h_mm_A: 'M/D/YY, h:mm A',
  M_D_YY: 'M/D/YY',
  mm_dd_yyyy: 'MM/DD/YYYY',
};

export const AcvDealerId = '199';
export const AcvDealerIdGuaranteePrice = 357;

export const MAX_CHARACTERS = 250;

export const Engine = {
  Acv: 'acv',
};

export const Mode = {
  MakeModel: 'make_model',
};

export const AppraisalSource = {
  AppraisalOffer: 'appraisal_offer',
  ManualLead: 'manual_lead',
  ReviewedOffer: 'reviewed_offer',
  StandaloneDisclosure: 'standalone_disclosure',
};

export const OfferPriceCalculation = {
  OfferLow: {
    percentSting: '34%',
    percentNumber: 12,
  },
  OfferMiddle: {
    percentSting: '64%',
    percentNumber: 4,
  },
  OfferHigh: {
    percentSting: '2%',
    percentNumber: 6,
  },
};

export const colorCollection = {
  black: { text: 'Black', value: 'black', hex: '#000' },
  blue: { text: 'Blue', value: 'blue', hex: '#00f' },
  brown: { text: 'Brown', value: 'brown', hex: '#964b00' },
  gray: { text: 'Gray', value: 'gray', hex: '#808080' },
  green: { text: 'Green', value: 'green', hex: '#0f0' },
  orange: { text: 'Orange', value: 'orange', hex: '#f60' },
  purple: { text: 'Purple', value: 'purple', hex: '#60f' },
  red: { text: 'Red', value: 'red', hex: '#f00' },
  silver: { text: 'Silver', value: 'silver', hex: '#c0c0c0' },
  tan: { text: 'Tan', value: 'tan', hex: '#d2b48c' },
  white: { text: 'White', value: 'white', hex: '#fff' },
  yellow: { text: 'Yellow', value: 'yellow', hex: '#ff0' },
};

export const colorList = {
  blue: '#00558C',
  lightBlue: '#4D91BD',
};

export const colorCollectionList = Object.values(colorCollection);

export const photoStatus = {
  WithPhotos: 'has_photos',
  WithoutPhotos: 'no_photos',
};

export const defaultFilters = {
  photos: true,
  store: true,
  year: true,
  make: true,
  model: true,
  style: true,
  appraiserId: false,
  source: true,
};

export const leadsTabTypes = {
  Active: 'active',
  Appointments: 'appointments',
  Archive: 'archive',
};

export const statusTypes = {
  Active: 'active',
  FollowUp: 'follow_up',
  BookedVist: 'booked_visit',
  ClosedLost: 'closed_lost',
  ClosedWon: 'closed_won',
};

export const statusByTab = {
  [leadsTabTypes.Active]: [
    statusTypes.Active,
    statusTypes.FollowUp,
    statusTypes.BookedVist,
  ],
  [leadsTabTypes.Archive]: [statusTypes.ClosedLost, statusTypes.ClosedWon],
};

export const appointmentDays = {
  DaysToAdd: 1,
  DaysToSubtract: -1,
};

export const LEAD_DATE_RANGE_MAX_DAYS_BACK = 150;

export const NOTIFICATION_POLL_INTERVAL = 60000;
export const TOAST_DURATION = 5000;

export const amazonLogo =
  'https://storage.googleapis.com/drv-img/amazon_logo.svg';
export const carAnimation =
  'https://storage.googleapis.com/drv-img/car-animation.gif';
export const loudSpeaker =
  'https://storage.googleapis.com/drv-img/loudspeaker.gif';
export const guaranteeProgramContact = 'support@clearcar.com';

export const bulkUploadTemplateLink =
  'https://storage.googleapis.com/clearcar-public/bulkupload_file_template.xlsx';

export const reconDefault = {
  customerName: 'Unknown',
  phoneNumber: 'XXX-XXX-XXXX',
  vehicleInfo: 'Unknown Vehicle',
  finalOffer: '0.00',
};

export const ACCIDENT_QUESTION_ID = 182;
export const KEYS_QUESTION_ID = 183;
export const KEYS_QUESTION_CONFIG = {
  id: KEYS_QUESTION_ID,
  label: 'Keys',
  title: 'Keys',
  default_answer: null,
  ml_key: 'keys',
  key: 'keys',
  description: '',
  type: 'radio',
  subquestions: [],
  options: [
    {
      order: 1,
      ml_key: 'keys',
      description: '0',
    },
    {
      order: 2,
      ml_key: 'keys',
      description: '1',
    },
    {
      order: 3,
      id: 66,
      ml_key: 'keys',
      description: '2+',
    },
  ],
};
export const ACCIDENT_QUESTION_CONFIG = [
  {
    title: 'Accidents',
    description: 'Has the vehicle been in any accidents?',
    order: 21,
    ml_key: 'accident',
    key: 'accident',
    id: ACCIDENT_QUESTION_ID,
    subquestions: [],
    type: 'string',
    options: [
      {
        order: 1,
        id: 93,
        ml_key: 'accident',
        description: '0',
      },
      {
        order: 2,
        id: 94,
        ml_key: 'accident',
        description: '1',
      },
      {
        order: 3,
        id: 95,
        ml_key: 'accident',
        description: '2+',
      },
    ],

  },
];
export const PRICE_ERROR_CODE = '006';
export const MILEAGE_DELTA_THRESHOLD = 300;
export const TOAST_NOTIFICATION_DELAY = 1000;
export const NOTIFICATION_COLORS = {
  success: { border: '#006C4C', bg: '#F4FFF6' },
  info: { border: '#0061A5', bg: '#F0F8FF' },
};